"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const alert = (message, type = "default") => {
    var _a;
    let alert = document.querySelector("#js--alert");
    if (!alert) {
        // create the stack message elements
        const ElAlert = document.createElement("div");
        const ELAlertP = document.createElement("p");
        const ELAlertButton = document.createElement("button");
        const ELAlertButtonSpan = document.createElement("span");
        ElAlert.setAttribute("class", "alert-snackbar alert-snackbar--close");
        ElAlert.setAttribute("id", "js--alert");
        ELAlertButton.setAttribute("type", "button");
        ELAlertButtonSpan.innerHTML = "&#10005";
        ELAlertButton.appendChild(ELAlertButtonSpan);
        ElAlert.appendChild(ELAlertP);
        ElAlert.appendChild(ELAlertButton);
        (_a = document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.appendChild(ElAlert);
        alert = document.querySelector("#js--alert");
    }
    const alertText = document.querySelector("#js--alert p");
    const alertButton = document.querySelector("#js--alert button");
    alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--error");
    alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--success");
    alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--open");
    alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--close");
    alert === null || alert === void 0 ? void 0 : alert.classList.add("alert-snackbar--open");
    if (type === "success") {
        alert === null || alert === void 0 ? void 0 : alert.classList.add("alert-snackbar--success");
    }
    if (type === "error") {
        alert === null || alert === void 0 ? void 0 : alert.classList.add("alert-snackbar--error");
    }
    if (alertText)
        alertText.innerHTML = message;
    const timeout = setTimeout(() => {
        alert === null || alert === void 0 ? void 0 : alert.classList.add("alert-snackbar--close");
        alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--error");
        alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--success");
        alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--open");
    }, 5000);
    alertButton === null || alertButton === void 0 ? void 0 : alertButton.addEventListener("click", () => {
        clearTimeout(timeout);
        alert === null || alert === void 0 ? void 0 : alert.classList.add("alert-snackbar--close");
        alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--error");
        alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--success");
        alert === null || alert === void 0 ? void 0 : alert.classList.remove("alert-snackbar--open");
    });
};
exports.default = alert;
